<template>
    <div class="select-region-container">
        <div class="menu-navs p-x-30">
            <div class="p-t-5 link-nav__active">
                <span class="tabPanel link-nav  active cursor preferences">preferences </span>
            </div>

            <div class="closed-menu-navs cursor "
            >
                <svg v-if="!visible_select" @click="showSelect();visible_select = true" width="24" height="24"
                     viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M7.008 10.996L2.004 7.992l5.004-2.996v1.997h6.996v1.998H7.008v2.005z" fill="#000"></path>
                </svg>
                <svg v-on:click="$parent.visible_country = !$parent.visible_country;showSelect();visible_select = true"
                     width="24px" height="24px" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z"
                        fill="#0F0F0F"></path>
                </svg>
            </div>

        </div>
        <hr>


        <div class="link-nav_ link-nav_select" v-if="visible_select">

            <div class="country_select ">
                <label>country</label>
                <div class="country_select_search border relative" @click="showSelect();visible_country = true"
                     v-if="select_country">
                    {{ select_country[$store.state.settings.lang] }}
                    <svg width="267" height="38" viewBox="0 0 267 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M244.325 14.7148L248.731 19.121L253.137 14.7148" stroke="black" stroke-width="0.6"/>

                    </svg>
                </div>

            </div>

            <div class="lang_select " v-if="languages.find(item => item.code === $store.state.settings.lang)">
                <label>launguage</label>
                <div class="country_select_search border relative" @click="showSelect();visible_lang = true">
                    {{ languages.find(item => item.code === select_lang)[select_lang] }}
                    <svg width="267" height="38" viewBox="0 0 267 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M244.325 14.7148L248.731 19.121L253.137 14.7148" stroke="black" stroke-width="0.6"/>
                    </svg>
                </div>

            </div>

            <div class="btn_select">
                <button class="air-btn_select" @click="setSettings">continue</button>
            </div>

        </div>
        <div class="link-nav_ link-nav_country" v-if="visible_country">
            <div class="title p-10">
                {{ trans('Select a country or region. The currency, cost and availability of the product may vary') }}
                ..
            </div>

            <div class="search-country flex jc-sb ai-center">
                <input class="search-country-js" type="text" :placeholder="trans('Search')"
                       @keyup="debounceCountry($event.target.value, 350)">
                <svg class="cursor" width="16" height="16" viewBox="0 0 16 16" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M7.25 12.5C10.1495 12.5 12.5 10.1495 12.5 7.25C12.5 4.35051 10.1495 2 7.25 2C4.35051 2 2 4.35051 2 7.25C2 10.1495 4.35051 12.5 7.25 12.5Z"
                        stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M10.9619 10.9624L13.9994 13.9999" stroke="black"
                          stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>


            </div>


            <ul class="lang country-js flex-column scroll m-t-10 h-50-vh" v-if="countries.length > 0">
                <a v-for="country in countries"
                   @click.prevent="select_country = country;showSelect();visible_select = true"
                   class="flex jc-sb li-item cursor current_country" v-show="country.active">

                    <div class="flex h-65 jc-center m-l-10 ai-center gap-20">
                        <img class="png-flag" :src="'/img/png100px/'+country.code.toLowerCase()+'.png'"
                             alt="">
                        <span class="lang-active lang-search">{{ country[$store.state.settings.lang] }}</span>

                        <span class="lang-active" v-if="country.currency">{{ country.currency.code }}</span>

                        <span class="lang-active sign">{{ country.currency.sign }}</span>
                    </div>
                    <span class="flex ai-center jc-center m-r-20">
                                                <span class="arrows current_country_set">

                                            <img v-if="country.id == $store.state.settings.country.id" class="arrows-active"
                                                 :src="'/img/svg/arrows.svg'">
                                                 </span>

                                             </span>

                </a>

            </ul>
        </div>
        <div class="link-nav_ link-nav_country" v-if="visible_lang">
            <div class="title p-10">
                {{ trans('Select the language in which you want to use the site') }}
            </div>


            <ul class="lang country-js flex-column scroll m-t-10 h-50-vh" v-if="languages.length > 0">
                <li class="flex jc-sb li-item cursor" v-for="language in languages"
                    @click="select_lang = language.code;showSelect();visible_select = true">
                    <div class="flex-column h-65 jc-center m-l-10 gap-10">
                        <span class="lang-active ">{{
                                languages.find(item => item.code === $store.state.settings.lang)[language.code]
                            }}</span>
                        <span class="lang-no-active">{{
                                languages.find(item => item.code === language.code)[language.code]
                            }}</span>
                    </div>
                    <span class="flex ai-center jc-center m-r-20" v-if="language.code === $store.state.settings.lang">
                        <span class="arrows">
                            <img class="arrows-active" src="https://batnorton.com/img/svg/arrows.svg" alt="">
                        </span>
                    </span>

                </li>

            </ul>
        </div>

    </div>
</template>
<style scoped>
.preferences {
    font-family: 'Helvetica Neue', serif;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 29px;
    text-transform: uppercase;
    color: #000000;
}

.relative {
    position: relative;
}

.relative svg {
    position: absolute;
    top: 2px;
    right: 0px;
}

.air-btn_select {
    background: #000000;
    font-family: 'HelveticaNeueCyr', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 13.818px;
    line-height: 120%;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: #FFFFFF;
    padding: 10px;
    width: 100%;
    cursor: pointer;
    margin-top: 30px;
    margin-bottom: 20px;
}

.btn_select, .lang_select, .country_select {
    width: 80%;
    padding: 10px;
}

.country_select, .lang_select {
    padding-top: 30px;
}

.link-nav_select {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 0 auto;
}

.border {
    border: 1px solid #000;
    padding: 10px;
    margin-top: 5px;
}

label {
    text-transform: uppercase;

    font-family: 'Helvetica Neue', serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 29px;
}

.closed-menu-navs {
    display: flex;
    align-items: center;
    gap: 10px;
}
</style>
<script>
export default {

    name: "Globe",
    data() {
        return {
            countries: [],
            languages: [],
            visible_select: true,
            visible_country: false,
            visible_lang: false,
            select_lang: null,
            select_country: null,
        }
    },
    mounted() {

        this.setCountries()
        this.setLanguage()
        this.setSelect()

    },
    methods: {
        setSelect() {
            this.select_country = this.$store.state.settings.country
            this.select_lang = this.$store.state.settings.lang
        },
        showSelect() {
            this.visible_select = false
            this.visible_country = false
            this.visible_lang = false

        },
        debounceCountry(search, debounceDuration = 300) {
            if (this.timeoutId !== null) {
                clearTimeout(this.timeoutId);
            }
            let lang;
            lang = this.$store.state.settings.lang
            this.timeoutId = setTimeout(_ => {

                this.countries = this.countries.sort(function (item) {


                    if (item[lang].toLowerCase().indexOf(search) >= 0) {
                        item.active = true

                    } else {
                        item.active = false

                    }

                });
            }, debounceDuration);
        },
        async setCountries() {
            let keys = 'countries'
            const keysUpdatedAt = 'countries_updated_at'
            const maxAgeMs = 24 * 60 * 60 * 1000 // 24 часа
            const raw = localStorage.getItem(keys)
            let useCache = !!raw
            if (raw) {
                const updatedAt = localStorage.getItem(keysUpdatedAt)
                if (!updatedAt || Date.now() - parseInt(updatedAt, 10) > maxAgeMs) {
                    useCache = false
                    localStorage.removeItem(keys)
                    localStorage.removeItem(keysUpdatedAt)
                }
            }
            if (useCache && raw) {
                this.$store.state.settings.countries = JSON.parse(raw)
            } else {
                await axios.get('/api/v1/get-countries',{params:this.setParam()})
                    .then(data => {

                        this.$store.state.settings.countries = data.data.sort((a, b) => (a.sort > b.sort) ? 1 : -1);

                        this.updateStorage(this.$store.state.settings)
                        this.updateStorage(this.$store.state.settings.countries,keys)
                        localStorage.setItem(keysUpdatedAt, String(Date.now()))
                    })
            }
            this.countries = this.$store.state.settings.countries
            let code;
            code = this.$store.state.settings.country.code

            this.$store.state.settings.countries = this.countries.sort(function (x, y) {
                return x.code === code ? -1 : y.code === code ? 1 : 0;
            });


        },
        async setLanguage() {
            let keys = 'language'
            if (localStorage.getItem(keys)) {
                this.$store.state.settings.language = JSON.parse(localStorage.getItem(keys));
            } else {
                await axios.get('/api/v1/get-language',{params:this.setParam()})
                    .then(data => {

                        this.$store.state.settings.language = data.data.sort((a, b) => (a.sort > b.sort) ? 1 : -1);
                        this.updateStorage(this.$store.state.settings)
                        this.updateStorage(this.$store.state.settings.language,keys)

                    })
            }
            this.languages = this.$store.state.settings.language
            let lang;
            lang = this.$store.state.settings.lang
            this.$store.state.settings.language = this.languages.sort(function (x, y) {
                return x.code === lang ? -1 : y.code === lang ? 1 : 0;
            });


        },


        setSettings() {


            if (this.$store.state.settings.lang !== this.select_lang || this.$store.state.settings.country.code !== this.select_country.code) {
                this.$store.state.settings.country = this.select_country
                this.$store.state.settings.lang = this.select_lang

                // document.cookie = "lang="+this.select_lang+";path=/;max-age=2629743";
                // document.cookie = "countryCode="+this.select_country.code+";path=/;max-age=2629743";
                // location.reload()
                window.location.href = window.location.pathname+`?set-lang=${this.select_lang}&set-countryCode=${this.select_country.code}&set-basket=reset`;
            }


        }

    },


}
</script>


